const WORDS = ["Thoughts pressed like violets", "Strung by hand", "Secrets kept at the wrist", "Lavender after midnight", "Every stone has a story", "Written under the moon"];

export const Marquee = () => (
  <section className="relative border-y border-purple-400/15 py-8 overflow-hidden bg-[#170a24]" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center font-display italic text-3xl md:text-5xl text-purple-200/90 px-8">
          {w}
          <svg viewBox="0 0 24 24" className="w-5 h-5 ml-16 text-amber-200" fill="currentColor"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
        </span>
      ))}
    </div>
  </section>
);
